import React, { useState } from "react";
import { sendMail } from "./../service/formService";

const ContactForm = () => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    message: "",
    error: "",
  });

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      name: values.name,
      email: values.email,
      message: values.message,
    };
    try {
      const { data: response } = await sendMail(formData);
      if (response === true) {
        setValues({ ...values, error: "", name: "", email: "", message: "" });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        setValues({ ...values, error: ex.response.data });
      }
    }
  };

  return (
    <div>
      <h3 className="mt-1 fw-bold text-center">CONTACT FORM</h3>
      <form className="" onSubmit={handleSubmit}>
        <div class="mb-3">
          <label className="form-label" htmlFor="name">
            Name
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            placeholder="Your Name"
            value={values.name}
            onChange={handleChange("name")}
          />
        </div>
        <div class="mb-3">
          <label className="form-label" htmlFor="email">
            Email address
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="Your Email Address"
            value={values.email}
            onChange={handleChange("email")}
          />
        </div>
        <div class="mb-3">
          <label className="form-label" htmlFor="message">
            Message
          </label>
          <textarea
            className="form-control"
            id="message"
            rows="3"
            placeholder="Your Message"
            value={values.message}
            onChange={handleChange("message")}
          />
        </div>
        <button
          type="submit"
          className="btn btn-dark"
          disabled={
            values.name === "" || values.email === "" || values.message === ""
              ? true
              : false
          }
        >
          Send Mail
        </button>
        {values.error && <h6 className="text-danger">{values.error}</h6>}
      </form>
    </div>
  );
};

export default ContactForm;
